import { useEffect, useState } from "react";
import { Global } from "@emotion/react";
import { Skeleton, SwipeableDrawer } from "@mui/material";
import { DronerListCard } from "./DronerCard";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import { DetailedSearchPage } from "../types/cmsLocalizationTypes";

export function SmallSearchView({
  selectedDroners,
  drawerBleeding,
  localizedPageContent,
  isOpen,
}: {
  selectedDroners: any[];
  drawerBleeding: number;
  localizedPageContent: DetailedSearchPage;
  isOpen?: boolean;
}) {
  const [open, setOpen] = useState(isOpen);

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };

  useEffect(() => {
    if (selectedDroners.length > 0) {
      setOpen(true);
    }
  }, [selectedDroners]);

  function handleClick(e: any) {
    const header = document.getElementById("header");
    if (header?.contains(e.target) || !open) setOpen(!open);
  }

  return (
    <div className="h-full">
      <Global
        styles={{
          ".MuiDrawer-root > .MuiPaper-root": {
            height: `calc(90% - ${drawerBleeding}px)`,
            overflow: "visible",
          },
        }}
      />
      {!open && (
        <button
          className="p-fixed text-text center-horizontal dept-l-5 bg-surface rounded-all-normal"
          onClick={toggleDrawer(false)}
          style={{
            bottom: drawerBleeding + 10,
          }}
        >
          <MenuRoundedIcon /> {localizedPageContent.list}
        </button>
      )}
      <SwipeableDrawer
        anchor="bottom"
        open={open}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
        swipeAreaWidth={drawerBleeding + 10}
        disableSwipeToOpen={false}
        ModalProps={{
          keepMounted: true,
        }}
        onClick={(e) => {
          handleClick(e);
        }}
      >
        <div
          onClick={(e) => {
            handleClick(e);
          }}
          className={`
            absolute   rounded-tr-normal rounded-tl-normal right-none left-none overflow-y-auto
          ${open ? "bg-background pointer" : "glass-card"}
          `}
          style={{
            top: -drawerBleeding,
            visibility: "visible",
            height: drawerBleeding,
          }}
          id="header"
        >
          <div
            className="bg-text rounded-all-full p-absolute "
            style={{
              width: 40,
              height: 6,
              top: 8,
              left: "calc(50% - 15px)",
            }}
          />
          <div className="p-large text-center">
            {selectedDroners?.length ? (
              <p>
                {selectedDroners.length} {localizedPageContent.searchResultText}
              </p>
            ) : (
              <p>{localizedPageContent.searchLoadingText}</p>
            )}
          </div>
        </div>
        <div
          className="h-full bg-background  overflow-y-auto hide-scrollbar pb-large"
          style={{ marginTop: -45, zIndex: 1 }}
        >
          <div className="flex  col gap-normal p-normal ">
            {selectedDroners?.length
              ? selectedDroners?.map((item: any, i: number) => (
                  <DronerListCard key={i} droner={item} />
                ))
              : [...Array(40)].map((item, i) => (
                  <Skeleton
                    className="rounded-all-normal"
                    variant="rectangular"
                    key={i}
                    width="100%"
                    height={118}
                  />
                ))}
          </div>
        </div>
      </SwipeableDrawer>
    </div>
  );
}
